import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CREATE_TEMPLATE,
  REMOVE_TEMPLATE,
  UPDATE_TEMPLATE,
} from '../graphql/mutation/notification-template.mutation';
import { GET_NOTIFICATION_BY_ID, GET_SERVICE_DROPDOWN, NOTIFICATION_TEMPLATES } from '../graphql/queries/notification-template.query';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  constructor(private apollo: Apollo) {}

  notificationTemplate(id: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_NOTIFICATION_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.notificationTemplate || []));
      
  }
  notificationTemplates(search: string = ''): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: NOTIFICATION_TEMPLATES,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.notificationTemplates || []));
      
  }
  serviceDropdown(search: string = ''): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_SERVICE_DROPDOWN,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.serviceDropDown || []));
      
  }

  createNotificationTemplate(input: any): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: CREATE_TEMPLATE,
      variables: {
        input,
      },
    });
  }

  updateNotificationTemplate(id:any, input: any): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: UPDATE_TEMPLATE,
      variables: {
        id,
        input,
      },
    });
  }

  removeNotificationTemplate(id: number): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: REMOVE_TEMPLATE,
      variables: { id },
    });
  }

  // removeServiceTask(id: number): Observable<any> {
  //   return this.apollo.use('project').mutate({
  //     mutation: REMOVE_SERVICE_TASK,
  //     variables: { id },
  //   });
  // }

  // removeServiceTaskAssignment(id: number): Observable<any> {
  //   return this.apollo.use('project').mutate({
  //     mutation: REMOVE_SERVICE_TASK_ASSIGNMENT,
  //     variables: { id },
  //   });
  // }
}
